<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import DevicePixelRatio from "./utils/devicePixelRatio";
export default {
  name: "App",
  components: {},
  created() {
    // new DevicePixelRatio().init();
  },
  // 禁用浏览器放大和缩小功能
  mounted() {
    window.addEventListener("wheel", this.handleWheel, { passive: false });
    window.addEventListener("touchmove", this.handleTouchMove, { passive: false });
  },
  beforeUnmount() {
    window.removeEventListener("wheel", this.handleWheel);
    window.removeEventListener("touchmove", this.handleTouchMove);
    window.removeEventListener("resize", this.removeResize);
  },
  methods: {
    removeResize() {
      console.log("移除resize事件");
    },
    handleWheel(event) {
      if (event.ctrlKey) {
        event.preventDefault();
      }
    },
    handleTouchMove(event) {
      if (event.touches.length > 1 || (event.scale && event.scale !== 1)) {
        event.preventDefault();
      }
    },
  },
};
</script>

<style>
@import "@/style/elStyle.css";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  /* background-image: url('@/assets/bg.png'); */
  /* background-size: 100% 100%; */
  overflow: auto;
}

html,
body {
  margin: 0 auto;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.page-header {
  cursor: pointer;
  text-align: center;
  background-color: #0175d6;
  color: white;
  border-radius: 10px 10px 0 0;
  margin-right: 10pt;
  width: 160px;
  height: 20px;
  line-height: 20px;
  padding: 10px;
  font-size: 16px;
}

.page-headers {
  background-color: white;
  color: #0175d6;
}

.tabs {
  display: flex;
}

.yellow {
  color: #ff9600;
}

.green {
  color: #00c800;
}

/* 强制显示滚动条 */
/* .el-scrollbar__bar {
  opacity: 1 !important;
} */

::-webkit-scrollbar {
  width: 5px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(27, 126, 240, 0.2);
  background: #eaf3fc;
}

.resetHomeDate {
  left: var(--left-date) !important;
  top: var(--top-date) !important;
}

.resetCascader {
  left: var(--left-cascader) !important;
  top: var(--top-cascader) !important;
}
</style>
